import { render, staticRenderFns } from "./PartnerCreate.vue?vue&type=template&id=b8b5956e&scoped=true&"
import script from "./PartnerCreate.vue?vue&type=script&lang=js&"
export * from "./PartnerCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8b5956e",
  null
  
)

export default component.exports